import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useMyCoupon(id: string) {
    const { data, status } = useQuery(queries.coupons.detail(id));
    const { pop } = useFlow();
    const toast = useToast();
    const { t } = useTranslation('coupon');

    useEffect(() => {
        if (status === 'error') {
            toast.error(t('detail.notFound'));
            pop();
        }
    }, [data]);
    return { coupon: data, isLoading: status === 'pending' };
}

export default useMyCoupon;
